import React from 'react';
import { Icon } from 'antd';

import formatPrice from '~helpers/currency';

export default function Card({ commission = {}, t }) {
  return (
    <div className="card-wrapper">
      <div className="card-title">{commission?.landlordName}</div>
      <div className="content-container">
        <div className="booking-count">
          <div className="icon-wrapper">
            <Icon type="schedule" className="schedule-icon" theme="filled" />
          </div>
          <div className="booking-count__wrapper">
            <span className="count">{commission?.bookingNumber}</span>
            <span className="all-bookings">{t('cms.booking.commission_report.all_bookings')}</span>
          </div>
        </div>
        <div className="amount-container">
          {commission?.commissions?.map((item, index) => {
            if (index > 1) return;
            return (
              <div className="amount" key={index}>
                <span className="currency">{item?.currency}</span>
                <span className="price">{formatPrice(item?.amount, item?.currency)}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
